import {RecordForm} from '../forms/RecordForm';


import {useOrganization} from '../hooks/useOrganization.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useOrganization();

    return (
        <FormPageLayout
            title='Add Organization'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/organizations')}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
